import type { erros as pt } from '../pt-BR/erros';
import type { Traducao } from '../Traducao';

export const erros = {
  REQUISICAO_INVALIDA: 'Los datos enviados no son válidos.',
  NAO_AUTENTICADO: 'Tu sesión ha expirado. Inicia sesión de nuevo.',
  SEM_PERMISSAO: 'No tienes permiso para esta acción.',
  NAO_ENCONTRADO: 'No encontrado.',
  MUITAS_REQUISICOES: 'Demasiados intentos. Espera un minuto.',
  ERRO_INESPERADO: 'Ocurrió un error inesperado. Inténtalo de nuevo.',
  REDE: 'Falla de conexión. Inténtalo de nuevo.',
  CREDENCIAIS_INVALIDAS: 'Correo o contraseña no válidos.',
  USUARIO_NAO_ENCONTRADO: 'Usuario no encontrado.',
  USUARIO_JA_EXISTE: 'Ya existe un usuario con este correo.',
  LOGIN_SENHA_DESLIGADO: 'El inicio de sesión con contraseña está desactivado.',
  REFRESH_INVALIDO: 'Tu sesión ha expirado. Inicia sesión de nuevo.',
  AXIIS_INDISPONIVEL:
    'El registro de profesionales no está disponible temporalmente. Inténtalo de nuevo en unos minutos.',
  PERIODO_INVALIDO: 'La fecha de fin no puede ser anterior a la de inicio.',
  ENTREGA_PREVISTA_INVALIDA:
    'Indique las dos fechas y que la fecha final no sea anterior a la inicial.',
  OUTRA_CAMPANHA_ATIVA: 'Ya existe una campaña activa: {{nome}}. Desactívala antes.',
  CAMPANHA_NAO_ENCONTRADA: 'Campaña no encontrada.',
  CEP_INVALIDO: 'El código postal debe tener 8 dígitos.',
  CEP_NAO_ENCONTRADO: 'Código postal no encontrado.',
  CEP_INDISPONIVEL: 'La consulta de código postal no está disponible temporalmente.',
  RESPOSTA_INVALIDA: 'Hay respuestas inválidas. Revise los campos marcados.',
  RESPOSTA_DESATUALIZADA:
    'Sus respuestas se modificaron en otra ventana. Mostramos la versión más reciente; revísela antes de guardar de nuevo.',
  SEM_VINCULO:
    'No encontramos su registro de profesional. Contacte al equipo responsable de la campaña.',
  NAO_PARTICIPANTE:
    'Usted no está en la lista de participantes de esta campaña. Contacte al equipo responsable de la campaña.',
  PARTICIPANTE_EXCLUIDO: 'Usted ya no forma parte de esta campaña.',
  CAMPANHA_AGENDADA: 'La campaña aún no ha comenzado.',
  CAMPANHA_FECHADA: 'La campaña no está aceptando respuestas.',
  EXPORTACAO_INCONSISTENTE:
    'Respuestas con dirección o talla inválida: {{quantidade}}. Lleve la lista de abajo al soporte del sistema antes de exportar.',
  PARTICIPANTE_NAO_ENCONTRADO: 'Participante no encontrado.',
  AZURE_NAO_CONFIGURADO: 'El inicio de sesión de Microsoft no está configurado.',
  CAMPANHA_NAO_SINCRONIZAVEL: 'Solo se puede sincronizar una campaña que no haya terminado.',
  CAMPANHA_TERMINADA: 'El plazo de esta campaña ya terminó.',
  ULTIMO_ADMINISTRADOR: 'El sistema necesita al menos un administrador activo.',
  SINCRONIZACAO_EM_ANDAMENTO: 'Ya hay una sincronización en curso. Espera.',
  CAMPANHA_SEM_RETENTATIVA: 'Solo se puede intentar de nuevo en una campaña activa.',
  RODADA_EM_ANDAMENTO: 'Ya hay un envío en curso para esta campaña.',
  CAMPANHA_SEM_CONVITE:
    'Solo se pueden enviar invitaciones de una campaña activa que no haya terminado.',
  SELECAO_DESATUALIZADA: 'La lista cambió desde que usted seleccionó. Revise e inténtelo de nuevo.',
  VARIAVEL_DESCONHECIDA:
    'El texto tiene una variable desconocida. Use {nome}, {campanha}, {inicio} o {fim}.',
  SELECAO_VAZIA: 'Nadie de la selección está en la campaña para recibir la invitación.',
  INATIVO_NO_AXIIS: 'Esta persona está inactiva en el registro y no puede volver a la campaña.',
  JA_PARTICIPANTE: 'Esta persona ya es participante de la campaña.',
  NAO_ENCONTRADO_NO_AXIIS: 'Esta persona no fue encontrada en el registro.',
  EXPORTACAO_MUITO_GRANDE:
    'La lista tiene {{quantidade}} personas; el máximo por archivo es 5000. Aplique filtros y exporte de nuevo.',
} as const satisfies Traducao<typeof pt>;
